import { GraphQLError } from 'graphql/error';

export function isErrorAInvalidJWTError(err: GraphQLError) {
  return err.extensions.errorType === 'InvalidAuthToken';
}
